/* eslint-disable react/jsx-child-element-spacing */
import { AccordionDetails, AccordionSummary } from '@material-ui/core';
import MuiAccordion from '@material-ui/core/Accordion';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import * as moment from 'moment';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { CommaSeparator, GetFormat, amountFormate } from '../../../AppUtil/AppUtil';
import ExpandIcon from '../../../Component/Common/Profile/SvgIcon/ExpandIcon';

import qs from 'query-string';
import { withTranslation } from 'react-i18next';
import Loader from '../../../Component/Common/Loader';
import MobileFooter from '../../../Component/Common/Profile/MobileFooter';
import PageHeaderTitle from '../../../Component/Common/Profile/PageHeaderTitle';
import LoanService from '../../../Service/LoanService';

import './style.css';

const styles = _theme => ({
	table: {
		minWidth: 700
	}
});

const HUNDRED = 100;
const NO_OF_DAYS_IN_YEAR = 365;

const Accordion = withStyles({
	root: {
		'&$expanded': {
			margin: '2px 0'
		}
	},
	expanded: {}
})(MuiAccordion);

class AmortizationTable extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			_heading: '',
			_isLoading: false,
			_loans: null,
			typeOfUser: '   ',
			_lendami_service: 0,
			_tableBackgroundColor: '#FFC63C'
		};
	}

	startLoader = () => {
		this.setState({
			_isLoading: true
		});
	};

	stopLoader = () => {
		this.setState({
			_isLoading: false
		});
	};

	onBack = () => {
		const { id } = qs.parse(this.props.location.search);

		let url;

		if (this.props.location.search.includes('?notification=false')) {
			window.history.back();
		} else if (this.props.location.search.includes('&notification=true')) {
			url = `/admin/customer/custom-view/${id}?page=0&tab=2&notification=true`;
			window.location.href = url;
		} else if (this.props.location.search.includes('&transferdue=true')) {
			url = `/admin/customer/custom-view/${id}?page=0&tab=2&transferdue=true`;
			window.location.href = url;
		} else {
			const userId = this.state._loans.accepted_by;
			url = `/admin/customer/custom-view/${userId}?page=0&tab=2&notification=true`;
			window.location.href = url;
		}
	};

	getLoan = async () => {
		try {
			const { installment_id } = qs.parse(this.props.location.search);
			const response = await LoanService.getLoan(this.props.props.match.params.id, installment_id);
			if (response) {
				this.setState({
					// _loans: response.data, //the returned data is already filtered to be the value of .data from the fetching
					_loans: response,
					_tableBackgroundColor: response.loan_type === 'Lend' ? '#76C4EE' : '#FFC63C'
				});
				this.service_charge_fee();
			}
		} catch (err) {
			console.log('err: ', err);
		}
	};

	calculateInterestRate = data => {
		const emi_amount = parseFloat(data.emi_amount);
		const iRate = this.props.loanData.annual_rate / HUNDRED;
		const days = moment(data.installment_date).diff(moment(), 'days');
		const interestAmount = emi_amount * (1 + iRate / NO_OF_DAYS_IN_YEAR) ** days - emi_amount;
		const totalEmi = emi_amount + interestAmount;
		return amountFormate(totalEmi);
	};

	// popUpwhenPayNow = (data) => {
	//   Swal.fire({
	//     title: "",
	//     text:
	//       this.props.t("amortization_table.text_on_pay_now_popup") +
	//       this.calculateInterestRate(data),
	//     icon: "warning",
	//     showCancelButton: true,
	//     confirmButtonColor: "#3085d6",
	//     cancelButtonColor: "#d33",
	//     cancelButtonText: this.props.t("buttons.cancel"),
	//     confirmButtonText: this.props.t("buttons.ok"),
	//   }).then((result) => {
	//     if (result.value) {
	//       this.payNow(data.id);
	//     }
	//   });
	// };

	// payNow = async (id) => {
	//   try {
	//     this.startLoader();
	//     const response = await ApiService.PatchData(
	//       `${API_URLS.INSTALLMENTS}/${id}`,
	//       {}
	//     );
	//     await this.props.refreshState();
	//     if (!response.status) {
	//       toastError(response.data);
	//     }
	//     this.stopLoader();
	//   } catch (err) {
	//     this.stopLoader();
	//     console.log(err);
	//   }
	// };

	// setheadingWhenModifiedTable = () => {
	//   let _heading = "";
	//   if (this.props.fromModifiedScreen) {
	//     if (this.props.currentUserId === this.props.loanObject.last_modified_by) {
	//       _heading =
	//         "amortization_table.message_for_modified_amortization_table_for_borrower";
	//     } else {
	//       _heading =
	//         "amortization_table.message_for_modified_amortization_table_for_lender";
	//     }
	//     this.setState({
	//       _heading,
	//     });
	//   }
	// };

	// isPayNowGeneralconditionTrue = async () => {
	//   const currentUser = await Session.get("CURRENT_USER_INFO");
	//   const account = currentUser.profile.account || {};
	//   let result = false;
	//   if (
	//     this.props.typeOfUser === "BORROW" &&
	//     account.funding_source_id &&
	//     (this.props.loanData.state === LOAN_STATES.APPROVE ||
	//       this.props.loanData.state === LOAN_STATES.POST_MODIFIED)
	//   ) {
	//     result = true;
	//   }
	//   return result;
	// };

	// isPayNowButtonNeedToShow = (inst) => {
	//   if (this.isPayNowGeneralconditionTrue()) {
	//     if (
	//       inst.state === INSTALLMENT_STATE.NO_BANK_FAILED ||
	//       (inst.state === INSTALLMENT_STATE.ACH_CANCEL &&
	//         this.props.loanData.frequency === "LUMP_SUM")
	//     ) {
	//       return true;
	//     }
	//   }
	//   return false;
	// };

	// isCancelPaymentButtonToShow = (inst) => {
	//   let result = false;
	//   if (
	//     this.props.typeOfUser === "BORROW" &&
	//     inst.state === INSTALLMENT_STATE.ACH_PENDING
	//   ) {
	//     result = true;
	//   }
	//   return result;
	// };

	// generatePayNowOrCancelButton = (text, action, inst) => {
	//   return (
	//     <StyledTableCell align="center">
	//       <Button
	//         id={text === "cancel" ? "cancel-button" : "agree-button"}
	//         onClick={() => {
	//           action(inst);
	//         }}
	//       >
	//         {this.props.t(`buttons.${text}`)}
	//       </Button>
	//     </StyledTableCell>
	//   );
	// };

	// CancelPayment = async (inst) => {
	//   try {
	//     this.startLoader();
	//     const requestBody = {
	//       action: LOAN_MODIFICATION_ACTION.CANCEL_INSTALLMENT_TRANSFER,
	//       installment_id: inst.id,
	//     };
	//     const response = await LoanService.paymentAction(
	//       this.props.loanData.id,
	//       requestBody
	//     );
	//     await this.props.refreshState();
	//     if (!response.status) {
	//       toastError(response.data);
	//     }
	//     this.stopLoader();
	//   } catch (err) {
	//     console.log(err);
	//     this.stopLoader();
	//   }
	// };

	// popupOnCancelPayment = (data) => {
	//   popUpOnCancelTranfer(
	//     this.props.t("buttons.cancel_loan_transfer"),
	//     this.CancelPayment,
	//     data
	//   );
	// };

	service_charge_fee = () => {
		const result = JSON.parse(localStorage.getItem('SERVICE_CHARGE'));
		if (this.state._loans) {
			this.state._loans.installments.map(a =>
				result?.filter(m => {
					const total_base = Number(a.emi_amount);

					if (total_base >= m.min && total_base <= m.max) {
						this.setState({ _lendami_service: m.price });
					}
				})
			);
		}
	};

	componentDidMount() {
		this.getLoan();
	}

	// commented out since this is deprecated
	// componentWillMount() {
	//   // this.getLoan();
	//   // this.setheadingWhenModifiedTable();

	// }

	render() {
		// NOSONAR

		const { t } = this.props;

		const tableHeaderNavColor = '#FFC63C';

		if (this.state._loans) {
			this.state._loans.installments.sort((a, b) => {
				if (moment(a.installment_date).diff(moment(b.installment_date), 'days') > 0) {
					return 1;
				} else {
					if (moment(b.installment_date).diff(moment(a.installment_date), 'days') > 0) {
						return -1;
					} else {
						return 0;
					}
				}
			}); // NOSONAR
			const { installment_id } = qs.parse(this.props.location.search);
			const filtered_paid =
				this.props.location.search.includes('&type=installments-history') ||
				this.props.location.search.includes('&table=installments-search')
					? this.state._loans.installments?.filter(m => m.id === parseInt(installment_id))
					: this.state._loans.installments;

			return (
				<section className="amortization-container">
					<PageHeaderTitle className="amortization p-x-16" onClick={this.onBack} title="Amortization Table" />
					<Grid
						alignItems="center"
						className="mobile_grid_container"
						item
						justify="center"
						sm={12}
						style={{ marginTop: '3rem' }}
						xs={12}>
						<Accordion
							className="amortization_mobile_accordion_list_bg"
							expanded={false}
							style={{ marginTop: '3rem', backgroundColor: tableHeaderNavColor }}>
							<AccordionSummary>
								<Grid container spacing={1} columns={16}>
									<Grid xs={3} sm={3} md={3}>
										<Typography variant="h5" style={{ textAlign: 'center' }}>
											{t('label.date')}
										</Typography>
									</Grid>
									<Grid xs={3} sm={3} md={3}>
										<Typography variant="h5" style={{ textAlign: 'center' }}>
											{t('label.total_loan_payment')}
										</Typography>
									</Grid>
									<Grid xs={3} sm={3} md={3}>
										<Typography variant="h5" style={{ textAlign: 'center' }}>
											{t('label.remaining_balance')}
										</Typography>
									</Grid>
									{/* <Grid xs={3} sm={3} md={3} style={{ paddingRight: "4rem" }}> */}
									<Grid xs={3} sm={3} md={3}>
										<Typography variant="h5" style={{ textAlign: 'center' }}>
											{t('label.payment')}
										</Typography>
									</Grid>
								</Grid>
							</AccordionSummary>
						</Accordion>

						{filtered_paid.map((data, index) => {
							
							return (
								<Accordion
									className="amortization_mobile_accordion_details amortization-accordion"
									key={index}
									style={{ margin: 0 }}>
									<AccordionSummary
										aria-controls="panel1a-content"
										classes={{
											expandIcon: 'custom-expand-icon'
										}}
										expandIcon={<ExpandIcon />}
										id="panel1a-header">
										<Grid container spacing={1} columns={16}>
											<Grid xs={3} sm={3} md={3}>
												<Typography
													style={{ textAlign: 'center', marginLeft: '-7px', width: '100%' }}>
													{data.transfer_date
														? GetFormat(data.transfer_date)
														: GetFormat(data.installment_date)}
												</Typography>
											</Grid>
											<Grid xs={3} sm={3} md={3}>
												<Typography
													style={{
														textAlign: 'center',
														fontWeight: 'bold',
														marginLeft: '4px',
														width: '100%'
													}}>
													{' '}
													₱ {CommaSeparator(data.emi_amount)}
												</Typography>
											</Grid>
											<Grid xs={3} sm={3} md={3}>
												<Typography
													style={{
														textAlign: 'center',
														fontWeight: 'bold',
														marginLeft: '15px',
														width: '100%'
													}}>
													₱{' '}
													{data.remaining_amount <= 1
														? amountFormate(0.0)
														: CommaSeparator(data.remaining_amount)}
												</Typography>
											</Grid>
											<Grid xs={3} sm={3} md={3}>
												<Typography
													style={{ textAlign: 'center', marginLeft: '27px', width: '100%' }}>
													{data.installment_date < new Date().toISOString() &&
													data.state === 'DUE'
														? 'OVERDUE'
														: data.state === 'ACH_FAILED'
														? 'FAILED'
														: data.state === 'FORGIVE'
														? 'FORGIVEN'
														: t(`installment_state.${data.state}`)}
												</Typography>
											</Grid>
										</Grid>
									</AccordionSummary>

									<AccordionDetails>
										<Grid item sm={12} xs={12} className="amortization_mobile_list_grid">
											<ListItem>
												<ListItemText
													primary={t('label.principal')}
													secondary={`₱ ${CommaSeparator(data.principal_part)}`}
												/>
											</ListItem>
											<ListItem>
												<ListItemText
													primary={t('label.interest')}
													secondary={`₱ ${CommaSeparator(data.interest_part)}`}
												/>
											</ListItem>
											<ListItem>
												<ListItemText
													primary="LendAmi Fee"
													secondary={`₱ ${
														data.transaction_fee > 0
															? CommaSeparator(data.transaction_fee)
															: CommaSeparator(this.state._lendami_service)
													}`}
												/>
											</ListItem>
											{/* {this.state._loans.disbursal_mode === 'ACH' && (
											<ListItem>
												<ListItemText
													primary="LendAmi Fee"
													secondary={`₱ ${CommaSeparator(this.state._lendami_service) || 0}`}
												/>
											</ListItem>
										)} */}
											{/* {this.state._loans.disbursal_mode === 'OFFLINE' && (
											<ListItem>
												<ListItemText
													primary="Cash/Check"
													secondary={`₱ ${CommaSeparator(data.principal_part)}`}
												/>
											</ListItem>
										)} */}
										</Grid>
									</AccordionDetails>
								</Accordion>
							);
						})}
					</Grid>
					<MobileFooter onClick={this.onBack} />
				</section>
			);
		} else {
			return <Loader />;
		}
	}
}

export default withRouter(withTranslation()(withStyles(styles)(AmortizationTable)));
